<template>
  <div class="details_content_repeat">
    <QS-h4-title title="相关应收信息" />
    <QS-common-table
      :columns="payfeeInfoHeader"
      :data="payfeeInfoList"
      :loading="loading"
      :pagination="paginationData"
      @change="paginationChange"
    ></QS-common-table>
  </div>
</template>

<script setup>
import { ref, watch, getCurrentInstance } from 'vue'
import { getOrderReceivableList } from '@/api/domain/orders'
import config from '../config/detail'

const props = defineProps({
  payInfo: {
    type: Object,
  },
})

const { proxy } = getCurrentInstance()
const { payfeeInfoHeader } = config.call(proxy)
const payfeeInfoList = ref([])
const paginationData = ref({
  pageSize: 10,
  pageNum: 1,
  total: 0,
  pageSizes: [10, 20, 30, 50],
})
const loading = ref(false)

const getReceivableList = async () => {
  loading.value = true
  const { code, data } = await getOrderReceivableList({
    id: props.payInfo.id,
    pageNum: paginationData.value.pageNum,
    pageSize: paginationData.value.pageSize,
  })
  loading.value = false
  if (code === 1) {
    payfeeInfoList.value = data.items
    paginationData.value.total = data.totalNum
    paginationData.value.pageNum = data.pageNum
  }
}

const paginationChange = ({ pagination }) => {
  const { pageNum, pageSize } = pagination
  paginationData.value.pageNum = pageNum
  paginationData.value.pageSize = pageSize
  getReceivableList()
}


watch(() => props.payInfo.id, (val) => {
  if (val) {
    getReceivableList()
  }
}, { immediate: true })


</script>
